import { Vue } from '~/addiesaas'
import Datetime from './datetime'

const filters = {
    datetime: Datetime,
}

Object.entries(filters).forEach((filter, name) => {
    Vue.filter(name, filter)
})
